/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {UpdateMerchantRequest} from '@cash-web/protos/squareup/roster/mds.pb'
import {UpdateMerchantResponse} from '@cash-web/protos/squareup/roster/mds.pb'


export const updateMerchant = (request: UpdateMerchantRequest, options?: CashRequestOptions) => post<UpdateMerchantRequest, UpdateMerchantResponse>("/2.0/cash/update-merchant", request, {...options, rejectOnError: true })